import Proxy from './Proxy';

class NamespaceProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/namespace', parameters);
  }

  list_address_mosaic(data) {
    this.set_data(data);
    return this.submit('post', `${this.endpoint}/mosaicListByAddress`);
  }

  get_detail(address) {
    this.set_data({address});
    return this.submit('post', `account/detail`);
  }
}

export default NamespaceProxy;
